/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetAsPrintedModel as DigiworkMaitreDPosDtoOrderSetAsPrintedModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Order/set-as-printed-model';

export interface SetOrderBillAsReadyForPrint$Params {
      body?: DigiworkMaitreDPosDtoOrderSetAsPrintedModel
}

export function setOrderBillAsReadyForPrint(http: HttpClient, rootUrl: string, params?: SetOrderBillAsReadyForPrint$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setOrderBillAsReadyForPrint.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setOrderBillAsReadyForPrint.PATH = '/api/wtr/OrderBill/setorderbillasreadyforprint';
